import { render, staticRenderFns } from "./JobsCard.vue?vue&type=template&id=fbd6fb64&"
import script from "./JobsCard.vue?vue&type=script&lang=js&"
export * from "./JobsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports